<div id="register">

<div id="creatAccount">
    <h1 class="header">Create an account</h1>
    <div class="container">
      <div class="row">
        <div class="form">
          <form #f="ngForm" [formGroup]="registerForm" id="form">
            <div class="form-group">
                <label>Email address*</label>
                <input type="email" formControlName="email" class="form-control" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required>
                <p class="errorText" *ngIf="!registerForm.controls.email.valid && registerForm.controls.email.touched">
                  Email is required
                </p>
              </div>
            <div class="form-group">
              <label>Password*</label>
              <input type="password" class="form-control" formControlName="password">
              <p class="errorText" *ngIf="!registerForm.controls.password.valid && registerForm.controls.password.touched">
                Password is required
              </p>
              <label class="error">{{errorMessage}}</label>
              <label class="success">{{successMessage}}</label>
            </div>
            <button type="submit" id="registerButton" [disabled]="!f.valid" (click)="tryRegister(registerForm.value)" class="btn btn-info">Register</button>
          </form>
        </div>
      </div>
      <div>
        <div>
          <p style="margin-top: 10px;">Already have an account? <a [routerLink]="['/login']">Login</a></p>
        </div>
      </div>
    </div>
    </div>
</div>